export const removeExtraSpaces = (text: string): string =>
  text.replace(/\s\s+/g, ' ');
